import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import BackOffice from './routes/back-office'
import HoldSale from './routes/hold-sale'
import PatchSale from './routes/patch-sale'
import CancelSale from './routes/cancel-sale'
import ProtectPlus from './routes/protect-plus'
import Refundable from './routes/refundable'
import RefundableLegacy from './routes/refundable-legacy'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App/>
  },
  {
    path: '/back-office',
    element: <BackOffice/>,
    children: [
      {
        path: '/back-office/hold-sale',
        element: <HoldSale/>
      },
      {
        path: '/back-office/patch-sale',
        element: <PatchSale/>
      },
      {
        path: '/back-office/cancel-sale',
        element: <CancelSale/>
      }
    ]
  },
  {
    path: '/protect-plus',
    element: <ProtectPlus/>,
  },
  {
    path: '/refundable',
    element: <Refundable/>,
  },
  {
    path: '/refundable-legacy',
    element: <RefundableLegacy/>,
  }
])

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
